import React from 'react'
import { Dropdown } from 'antd'

import type { LntDropdownProps } from './types'

export const LntDropdown: React.FC<LntDropdownProps> = props => {
  const { children, items = [], ...restProps } = props
  return (
    <Dropdown
      { ...restProps }
      menu={ { items } }
    >
      { children }
    </Dropdown>
  )
}
